import { AnalyticsEvent } from "./analyticsEvent"
class PaginationInteractionEvent extends AnalyticsEvent {
    public pageNumber: string;
    constructor(page: string) {
        super();
        this.pageNumber = page;
    }
}
export { PaginationInteractionEvent }